import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useBankOperationsFilterFields } from './hooks/useBankOperationsFilterFields';

export const BankOperationsFilterChips: React.FC = () => {
  const fields = useBankOperationsFilterFields();

  return <FilterChips fields={fields} />;
};
